/** @format */

import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

import { connectRouter, routerMiddleware } from 'connected-react-router';

import rootSaga from './rootSaga';
import rootReducer from './rootReducer';
import rootMiddleware from './rootMiddleware';
import { createBrowserHistory, createMemoryHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { responsiveStoreEnhancer } from 'redux-responsive';

const persistConfig = {
  key: 'root',
  storage: storage,
  stateReconciler: autoMergeLevel2, // see "Merge Process" section for details.
};
const composeEnhancers =
  process.env.NODE_ENV !== 'production' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

/* middleware that needs to live outside the rootMiddleware */
const history = process.env.NODE_ENV !== 'test' ? createBrowserHistory() : createMemoryHistory();
const sagaMiddleware = createSagaMiddleware();

function configureStore(preloadedState, history) {
  const middleware = rootMiddleware([sagaMiddleware, routerMiddleware(history)]);

  const persistRootReducer = persistReducer(persistConfig, rootReducer);

  const store = createStore(
    connectRouter(history)(persistRootReducer),
    preloadedState,
    composeEnhancers(responsiveStoreEnhancer, applyMiddleware.apply(null, middleware)),
  );

  if (module.hot)
    module.hot.accept('./rootReducer', () => {
      const nextRootReducer = require('./rootReducer').default;
      store.replaceReducer(nextRootReducer);
    });

  sagaMiddleware.run(rootSaga);
  return store;
}

const store = configureStore({}, history);
const persistor = persistStore(store);
export { store, history, persistor };
export default store;



// WEBPACK FOOTER //
// ./src/store/configureStore.js